$(document).ready(function() {  
  // If the page has seller profile display tag
  if ($('#seller_name').length) {
    var brand_name = $('#seller_name').val();
    var personProfileUrl = "https://test-designers.lovethisstuff.com/SellerProfile/getprofiledetails?brand_name=" + brand_name;
    // Ajax call to get Seller Profile Details 
    $.ajax({
      url: personProfileUrl,
      type: 'GET',
      success: function(resp) {
        if (resp.messageType == "SUCCESS") {
          //Updating Seller Profile Image in Product Page
          if ($('.product_seller_display_image').length){
            var displayImgUrl = resp.displayImgUrl;
            
          	if(displayImgUrl != "" && displayImgUrl != false && displayImgUrl != "false" && displayImgUrl != null){
              $('.product_seller_display_image').attr("src",displayImgUrl);
              $('.product_seller_display_image').removeClass("hidden");
              $('#meet-seller-display-img').attr("src",displayImgUrl);
              $('#meet-seller-display-img').removeClass("hidden");
            }
          }
          
          $('#meet-seller-description p').text(resp.description);
          
          //Updating return policy
          if(typeof(resp.policyDetails) != "undefined" && resp.policyDetails !== null){
            var policy = resp.policyDetails;
            var return_exhange_flag = false;

            if(policy.accept_exchange == 'YES') {
              return_exhange_flag = true;
              $('.accept_exchange').show();
            } else {
              $('.no_accept_exchange').show();
            }
            if(policy.accept_return == 'YES') {
              return_exhange_flag = true;
              $('.accept_return').show();
            } else {
              $('.no_accept_return').show();
            }
            if(policy.accept_returns_condition == 'YES') {
              $('.accept_return_conditions_p').show();
            } else {
              $('.accept_return_conditions_p').hide();
            }
            if(policy.exchange_size_condition == 'YES') {
              $('.accept_exchange_size_condition_text').show();
            } else {
              $('.accept_exchange_size_condition_text').hide();
            }
            
            if(return_exhange_flag){
              $('span.no_days').html(policy.number_of_days);
              $('.show_accept_return_conditions').css("display", "block");
              $('#show-no-accept-return').css("display", "none");
            } else {
              $('.no_accept_exchange').hide();
              $('.no_accept_return').hide();
              $('.show_accept_return_conditions').css("display", "none");
              $('#show-no-accept-return').css("display", "block");
            }
            var items_cannt_return_list = "";
            if(policy.return_intimate_items == "YES"){
              items_cannt_return_list += "<li>Intimate items (for health/hygiene reasons)</li>" 
            }
            if(policy.return_perishable_items == "YES"){
              items_cannt_return_list += "<li>Perishable products (like food or flowers)</li>" 
            }
            if(policy.return_custom_items == "YES"){
              items_cannt_return_list += "<li>Custom or personalized orders</li>" 
            }
            if(policy.return_sale_items == "YES"){
              items_cannt_return_list += "<li>Items on sale</li>" 
            }
            if(policy.return_digital_items == "YES"){
              items_cannt_return_list += "<li>Digital downloads</li>" 
            }
            $('.items_cannt_return_list').html(items_cannt_return_list);

            var address_use_list = "";
            if(policy.use_contact_for_communication == "YES"){
              address_use_list += "<li>To communicate about customer order</li>" 
            }
            if(policy.use_contact_for_fulfilling_order == "YES"){
              address_use_list += "<li>To fulfill the order</li>" 
            }
            if(policy.use_contact_for_legal == "YES"){
              address_use_list += "<li>For legal reasons (like paying taxes)</li>" 
            }
            $('.address_use_list').html(address_use_list);
            
          } else {
            $('.policy_content').html("<h5>No policy added</h5>");
          }
        } else {
          $('.policy_content').html("<h5>No policy added</h5>");
        }
      },
      error: function(e) {
        //Do nothing
      }
    });
  }
});